module.exports = __webpack_public_path__ + "static/media/999321.5308d6c0.png";